import React from 'react'
import CategoryPill, { IPillStyle } from 'src/components/atoms/categoryPill'
import {
  Maybe,
  PrismicArticle,
  PrismicCategory,
} from 'src/typings/generated/graphql'
import { articleThumbnailImage } from 'src/utils/articlesHelper'

import * as Styles from './articleCard.module.scss'

type Props = {
  article: PrismicArticle
}

const ArticleCard = ({ article }: Props) => {
  const locale = process.env.PRISMIC_LOCALE || 'en-us'
  const category = article.data.category?.document as Maybe<PrismicCategory>

  const publishedDate = () => {
    const dateStr = article.data.post_date ?? article.first_publication_date
    const date = new Date(dateStr)

    return date
      .toLocaleDateString(locale, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
      })
      .replaceAll('/', '.')
  }

  return (
    <div className={Styles.articleCard}>
      <div className={Styles.imageWrapper}>
        <a
          href={article.data.url?.url ?? `/news/${article.uid}`}
          target={article.data.url?.url ? '_blank' : '_self'}
          rel="noreferrer"
          aria-label={article.data.title?.text ?? ''}
        >
          {articleThumbnailImage(article, Styles.image)}
        </a>
        {category && (
          <div className={Styles.category}>
            <CategoryPill
              category={category.data.name ?? ''}
              style={'grey-gold' as IPillStyle}
            />
          </div>
        )}
      </div>
      <a
        className={Styles.articleLink}
        href={article.data.url?.url ?? `/news/${article.uid}`}
        target={article.data.url?.url ? '_blank' : '_self'}
        rel="noreferrer"
      >
        <h4>{article.data.title?.text}</h4>
        <p>{publishedDate()}</p>
      </a>
    </div>
  )
}

export default ArticleCard
